import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Image, Card, Badge } from 'react-bootstrap';
import { LanguageProvider } from '../../../core/language-provider';
import { ResourceManager } from '../../../core/resource-manager';
import photo from '../../../assets/photo_home_evento.svg'
import moment from 'moment';




export default function CardEventoV2({ data, entity }) {

    const navigate = useNavigate();
    const [errors, setErrors] = useState(null);
    const [image, setImage] = useState(null);


    useEffect(() => {
        console.log('data-card', data)
        var imageV2 = {
            hash: data.hash,
            extension: data.extension
        }
        setImage(data.image ? ResourceManager.getFileUrl(data.image, 'event') : ResourceManager.getFileUrl(imageV2, 'event'))

    }, [data]);

    function clickAction() {

        navigate('/eventi/' + data.id)
    }


    if (data) {
        return (
            <Card role="button" onClick={clickAction} className='my-3 text-dark h-100' style={{ borderRadius: '20px' }}>
                <Card.Img className='image-hover' variant="top" src={image} style={{ borderStartEndRadius: '20px', borderStartStartRadius: '20px' }} />
                <Card.Body>
                    <Card.Text>
                        <small>{data.idCategory ? data.idCategory.name : data.category}</small>
                    </Card.Text>
                    <Card.Text style={{ minHeight: '70px' }}>
                        <h5>{data && data.name}</h5>
                    </Card.Text>
                    <Card.Text>
                        <Badge bg='light' pill className='text-black me-2'><small>Data: {data && moment(data.startDatetime).format('DD-MM-YYYY HH:mm')}</small></Badge>
                        {/* {moment(data.startDatetime).isAfter(moment()) ? <Badge bg='light' pill className='text-black'>Programmato</Badge> :
                            <Badge bg='light' pill className='text-black'>Concluso</Badge>} */}
                        {
                            moment().isAfter(data.endDatetime) ? (
                                <Badge bg="light" pill className="text-black">Concluso</Badge>
                            ) : moment().isBefore(data.startDatetime) ? (
                                <Badge bg="light" pill className="text-black">Programmato</Badge>
                            ) : (
                                <Badge bg="light" pill className="text-black">In corso</Badge>
                            )
                        }
                        {data && data.place && data.place !== "" ?
                            <Badge bg='light' pill className='text-black me-2'><small>Luogo: {data && data.place}</small></Badge>
                            : null}
                    </Card.Text>
                </Card.Body>
            </Card>
        );
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }

};